var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm.isLoading ? [_c('span', {
    staticClass: "icon mr-1"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1), _c('span', {
    staticClass: "label"
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.general.label.loading')) + "… ")])] : !_vm.sleSuggestions.length ? [_vm._v(" Er zijn geen dropship-mogelijkheden voor deze levering. ")] : [_c('b-row', {
    staticClass: "responsible-location-form mb-3"
  }, [_c('b-col', {
    staticClass: "pt-1",
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" Kies een leverancier: ")]), _c('b-col', {
    attrs: {
      "cols": "7"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.dropshipLocationsFormOptions,
      "label": "Dropshipper",
      "outlined": "",
      "dense": "",
      "required": ""
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function () {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null,
            "disabled": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.general.action.select-one')) + " ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.dropshipLocationId,
      callback: function ($$v) {
        _vm.dropshipLocationId = $$v;
      },
      expression: "dropshipLocationId"
    }
  })], 1)], 1), _c('b-row', {
    staticClass: "responsible-location-form mb-3"
  }, [_c('b-col', {
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" Leverdatum: ")]), _c('b-col', {
    attrs: {
      "cols": "7"
    }
  }, [_vm.isLoadingDispatchTypes ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _c('span', [_vm._v(_vm._s(_vm._f("date")(_vm.selectedLocationDeliveryDate)))])], 1)], 1)]], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }